// extracted by mini-css-extract-plugin
export default {"content":"index_content_n5Asi","other":"index_other_tOoRf","rules":"index_rules_Hl0Nt"};